export default "../fonts/akzidgrtskprolig-webfont.5b2634fd7c6744bbc0f9b6769ae84d11.woff2";